/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserMeResponse } from '../models/UserMeResponse';
import type { UserOrganizationsResponse } from '../models/UserOrganizationsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationProxiedService {
    /**
     * Read Users Me
     * @returns UserMeResponse Successful Response
     * @throws ApiError
     */
    public static readUsersMeAuthMeGet(): CancelablePromise<UserMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/me',
        });
    }
    /**
     * Get User Organizations
     * @returns UserOrganizationsResponse Successful Response
     * @throws ApiError
     */
    public static getUserOrganizationsAuthUserOrganizationsGet(): CancelablePromise<UserOrganizationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/user/organizations',
        });
    }
    /**
     * Get Available Permissions
     * Return all available permission values for the outreach platform.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getAvailablePermissionsAuthPermissionsGet(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/permissions',
        });
    }
}
